import { MenuItem, Select } from '@mui/material';
import { connect } from 'react-redux';

const BulkReassign = ({
  accountManagers,
  accountManager,
  setAccountManager,
  user,
}) => {
  const userId = user.id;
  return (
    <div className='mt-4 mb-4'>
      <p>Select New Account Manager</p>
      <Select
        className='font-normal full-width '
        inputProps={{
          name: 'status',
          id: 'status',
        }}
        value={accountManager}
        onChange={(e) => setAccountManager(e.target.value)}
      >
        {accountManagers
          .filter((each) => each._id !== userId)
          .map((each) => (
            <MenuItem value={each._id}>{each.name}</MenuItem>
          ))}
      </Select>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.auth.account,
  };
};

export default connect(mapStateToProps, null)(BulkReassign);
